module.exports = __webpack_public_path__ + "img/Powder-Shot_2.e25baa2.jpg";